import PromptQueue from "./prompt-queue";

export default PromptQueue;
